<template>
    <section class="indBlock titLeft">
        <div class="container">
            <div class="hd clearfix">
                <h3 class="clearfix"><a>生态链企业</a>
                    <el-button class="positionButton" type="primary" plain @click="handleCompany">更多企业>>
                    </el-button>
                </h3>
            </div>
            <ul class="factors clearfix enterprise">
                <li v-for="hotEnterprise in hotEnterpriseList" :key="hotEnterprise.id">
                    <div class="default-cursor">
                        <div class="top">
                            <p style="cursor: pointer" @click="handleCompanyItem(hotEnterprise)">
                                <img :src="imageLocation(hotEnterprise.logo)" alt="">
                                <span>{{ hotEnterprise.shortName }}</span>
                            </p>
                            <p class="spaceBetween default-cursor">
                                <span class="tag"><i v-for="(item, index) in hotEnterprise.industry" :key="index">{{ item }}</i></span>
                                <span class="location"><img src="@/pages/frontend/assets/images/icon_location.png"
                                                            alt=""> {{ hotEnterprise.city }}</span>
                            </p>
                        </div>
                        <div class="positionBox">
                            <el-carousel height="80px" direction="vertical" :autoplay="true" indicator-position="none">
                                <el-carousel-item v-for="(item, index) in hotEnterprise.jobList" :key="index">
                                    <p class="spaceBetween" @click="handleDetail(item)">
                                        <span>{{item.positionName}}</span>
                                        <span>{{ rangeFormatter(item) }}</span>
                                    </p>
                                    <p class="spaceBetween" @click="handleDetail(hotEnterprise.jobList2[index])">
                                        <span>{{hotEnterprise.jobList2[index].positionName}}</span>
                                        <span>{{ rangeFormatter(hotEnterprise.jobList2[index]) }} </span>
                                    </p>
                                </el-carousel-item>
                            </el-carousel>
                            <!-- <ul :class="['positionList',{marquee_top:animate}]">
                                <li class="spaceBetween" v-for="(f,i) in position" :key="i"><span>{{f.name}}</span><span>{{f.salary}}</span></li>
                            </ul> -->
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
    import {getHotEnterpriseInfo} from '@/api/enterprise'

    const YEAR_WAGES = 0;       // 年薪
    const MONTHLY_WAGES = 1;    // 月薪
    const DAILY_WAGES = 2;      // 日薪
    const HOURLY_WAGES = 3;     // 时薪
    const FACE_TO_FACE_WAGES = 4;     // 面议
    export default {
        name: 'Enterprise',

        data() {
            return {
                hotEnterpriseList: [],
                animate: false
            }
        },
        computed: {
            imageLocation() {
                return function (file) {
                    let imagePath = null;
                    if (file) {
                        imagePath = encodeURI(file);
                    } else {
                        imagePath = this.Cookies.get("DEFAULT_ENTERPRISE_IMG");
                    }
                    return `/files?imagePath=${imagePath}`;
                }
            }
        },
        methods: {
            handleCompanyItem(item) {
                if (process.env.NODE_ENV == "development") {
                    window.open(window.location.origin + "/frontend#/companyDetails/" + item.id);
                } else {
                    window.open(window.location.origin + "/#/companyDetails/" + item.id);
                }
            },
            // 打开职位详情
            handleDetail(job) {
                if (process.env.NODE_ENV == "development") {
                    window.open(window.location.origin + "/frontend#/jobDetails/" + job.id);
                } else {
                    window.open(window.location.origin + "/#/jobDetails/" + job.id);
                }
            },
            handleCompany() {
                if (process.env.NODE_ENV == "development") {
                    window.open(window.location.origin + "/frontend#/jobList?active=company");
                } else {
                    window.open(window.location.origin + "/#/jobList?active=company");
                }
            },
            /** 薪资范围格式化*/
            rangeFormatter(row) {
                let msg = '';
                let min = row.minimumWage;
                let max = row.maximumWage;
                switch (row.payMethod) {
                    case YEAR_WAGES:
                        msg = min / 10000 + '-' + max / 10000 + 'W•年';
                        break;
                    case MONTHLY_WAGES:
                        msg = min / 1000 + '-' + max / 1000 + 'K•月';
                        break;
                    case DAILY_WAGES:
                        msg = min + '-' + max + '•日';
                        break;
                    case HOURLY_WAGES:
                        msg = min + '-' + max + '•时';
                        break;
                    case FACE_TO_FACE_WAGES:
                        msg = "面议";
                        break;
                }
                return msg;
            },
            loadData() {
                getHotEnterpriseInfo().then((res) => {
                    this.hotEnterpriseList = res.data;
                    this.hotEnterpriseList.forEach((item, index) => {
                        item.industry = JSON.parse(item.industry);
                        item.city = item.city ? JSON.parse(item.city).join("") : '';

                        item.jobList2 = [...item.jobList, item.jobList[0]];
                        item.jobList2.shift();
                    });
                })
            }
            // showMarquee() {
            //     this.animate = true;
            //     setTimeout(()=>{
            //         this.position.push(this.position[0]);
            //         this.position.shift();
            //         this.position.push(this.position[0]);
            //         this.position.shift();
            //         this.animate = false;
            //     },1000)
            // }
        },
        created() {
            // setInterval(this.showMarquee, 4000)
            this.loadData();
        }
    };
</script>
